export const contactSentimentMap = {
    positive: {
        face: '😀',
        label: 'contact.sentiment.positive',
        tone: 'bg-success-100 text-success-700',
        bulletTone: 'bg-success-600',
    },
    neutral: {
        face: '😐',
        label: 'contact.sentiment.neutral',
        tone: 'bg-gray-200 text-gray-700',
        bulletTone: 'bg-gray-500',
    },
    negative: {
        face: '😕',
        label: 'contact.sentiment.negative',
        tone: 'bg-danger-100 text-danger',
        bulletTone: 'bg-danger-600',
    },
    unidentified: {
        face: '',
        label: 'contact.sentiment.unidentified',
        tone: 'bg-gray-200 text-gray-700',
        bulletTone: '',
    },
} as const;

export type ContactSentiment = keyof typeof contactSentimentMap;
